module.exports = __webpack_public_path__ + "media/images/common-nav/national-parks/arches_national_park-5d6411f03455e58bf9ec7cf1f4c13be1.jpg";